import { createFileRoute } from "@tanstack/react-router";
import { marketingHead } from "../marketing-content/head";

import { MarketingLegalPage } from "../components/marketing/MarketingLegalPage";
import { privacyDocument } from "../components/marketing/legalDocuments";

export const Route = createFileRoute("/privacy")({
  head: () => marketingHead("/privacy"),
  component: () => <MarketingLegalPage document={privacyDocument} />,
});
